// extracted by mini-css-extract-plugin
export default {"content":"CzTlF4CIoK8a4hJ72tvg"};